import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import styled, { css } from 'styled-components';
import { getDownloadUrl } from '@/utils';
import { useGetPhotoQuery } from '@/services/general-api';
import { useDeleteChildPhotoMutation, useSetChildPrimaryPhotoMutation } from '@/services/child-api';
import { CheckSvg, DownloadSvg, TrashSvg } from '@/assets/icons';
import Loading from '@/components/loading';
import Button from '@/components/button';

const W = 260;
const H = 260;

const Wrapper = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  max-width: ${W}px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const ImgWrapper = ({ isPrimary, ...props }) => <img alt="img" {...props} />;

const StyledImg = styled(ImgWrapper)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  padding: 0.25rem;
  background-color: #f2f4f8;
  border: 1px solid #c0cadd;
  border-radius: 0.28rem;
  max-width: 100%;
  max-height: ${H}px;
  height: auto;

  ${({ isPrimary }) =>
    isPrimary &&
    css`
      background-color: #00c191;
    `}
`;

// const Actions = styled.div`
//   position: absolute;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex-direction: column;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.5);
//   opacity: 0;
//   transition: opacity 0.3s;

//   &:hover {
//     opacity: 1;
//   }
// `;

const Photo = ({ info, refetch }) => {
  const { childId, isPrimary, childPhotoId: photoId, blobId } = info;
  const { data, isLoading } = useGetPhotoQuery({ photoId: blobId });
  const [setPrimary, { isLoading: setting }] = useSetChildPrimaryPhotoMutation();
  const [deletePhoto, { isLoading: deleting }] = useDeleteChildPhotoMutation();

  const handleSetPrimary = async () => {
    try {
      await setPrimary({ childId, photoId }).unwrap();
      refetch();
    } catch (err) {}
  };

  const handleDelete = async () => {
    try {
      await deletePhoto({ childId, photoId }).unwrap();
      refetch();
    } catch (err) {}
  };

  return (
    <Wrapper>
      {isLoading ? (
        <Loading size="default" />
      ) : (
        <>
          {/* <Img isPrimary={isPrimary} src={`data:image/jpeg;base64,${data}`} /> */}
          <StyledImg src={`data:image/jpeg;base64,${data}`} isPrimary={isPrimary} />
          <svg style={{ height: 0, position: 'absolute' }}>
            <defs>
              <filter id="icon-shadow">
                <feDropShadow dx="1" dy="1" stdDeviation="2" floodColor="#000000" />
              </filter>
            </defs>
          </svg>
          <Button
            type="link"
            icon={<TrashSvg style={{ filter: 'url(#icon-shadow)' }} />}
            onClick={() =>
              Modal.confirm({
                title: 'Are you sure delete this photo?',
                icon: <ExclamationCircleFilled />,
                okText: 'Yes',
                okType: 'danger',
                cancelText: 'No',
                onOk() {
                  handleDelete();
                },
              })
            }
            style={{ color: '#fff', position: 'absolute', right: '0px', top: '12px' }}
            loading={deleting}
          />
          {!isPrimary && (
            <Button
              type="link"
              icon={<CheckSvg style={{ filter: 'url(#icon-shadow)' }} />}
              loading={setting}
              onClick={handleSetPrimary}
              style={{ color: '#fff', position: 'absolute', right: '0px', top: '35px' }}
            />
          )}
          <Button
            type="link"
            icon={<DownloadSvg />}
            href={getDownloadUrl(`/blobs/${blobId}/download`)}
            style={{
              color: '#fff',
              backgroundColor: '#526a99',
              borderColor: '#526a99',
              width: '100%',
              marginTop: '-5px',
              height: 'revert-layer',
              borderRadius: '0.28rem',
            }}
          >
            Download
          </Button>
        </>
      )}
    </Wrapper>
  );
};

export default Photo;
